import { render, staticRenderFns } from "./MarkdownViewer.vue?vue&type=template&id=26053455&scoped=true&"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js&"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownViewer.vue?vue&type=style&index=0&id=26053455&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26053455",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26053455')) {
      api.createRecord('26053455', component.options)
    } else {
      api.reload('26053455', component.options)
    }
    module.hot.accept("./MarkdownViewer.vue?vue&type=template&id=26053455&scoped=true&", function () {
      api.rerender('26053455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/FileViewers/MarkdownViewer.vue"
export default component.exports